import { Component } from '@angular/core';

@Component({
  templateUrl: './oss.component.html',
  styleUrls: ['./oss.component.less']
})
export class OSSComponent {

  private host = window.location.host;

}



// WEBPACK FOOTER //
// ./src/app/oss/oss.component.ts